import {
  LOAD_DISTANCE,
  SHOW_DISTANCE,
  CREATE_DISTANCE,
  UPDATE_DISTANCE,
  DELETE_DISTANCE,
  IMPORT_DISTANCE,
  EXPORT_DISTANCE,
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldReload: false,
  data: {
    id: "",
    code: "",
    min_value: "",
    max_value: "",
    description: "",
    range_value: "",
  },
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_DISTANCE.REQUEST:
    case UPDATE_DISTANCE.REQUEST:
    case DELETE_DISTANCE.REQUEST:
    case IMPORT_DISTANCE.REQUEST:
    case EXPORT_DISTANCE.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false,
      };
    case LOAD_DISTANCE.REQUEST:
      return {
        ...state,
        data: initialState.data,
        ...msg,
        loading: true,
        shouldReload: false
      };
    case SHOW_DISTANCE.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
        shouldReload: false,
      };

    case LOAD_DISTANCE.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };

    case SHOW_DISTANCE.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        loading: false,
      };

    case CREATE_DISTANCE.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        loading: false,
      };

    case UPDATE_DISTANCE.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
      };

    case DELETE_DISTANCE.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true,
      };

    case IMPORT_DISTANCE.SUCCESS:
      return {
        ...state,
        success_msg: "import_success",
        loading: false,
        shouldReload: true,
      };

    case EXPORT_DISTANCE.SUCCESS:
      return {
        ...state,
        success_msg: "export_success",
        loading: false,
      };
    case LOAD_DISTANCE.FAILURE:
    case SHOW_DISTANCE.FAILURE:
    case CREATE_DISTANCE.FAILURE:
    case UPDATE_DISTANCE.FAILURE:
    case DELETE_DISTANCE.FAILURE:
    case IMPORT_DISTANCE.FAILURE:
    case EXPORT_DISTANCE.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false,
      };

    default:
      return state;
  }
};
